const pl = {
    /* App */
    "(shift) arrow up/down": "(shift) strzałki góra/dół",
    "higher/lower BPM": "zwiększ/zmniejsz BPM",
    "arrow left/right": "strzałki lewa/prawa",
    "previous/next step according to plan": "poprzedni/następny krok wg planu",
    "start/stop": "zacznij/zatrzymaj",
    "stop": "zatrzymaj",

    /* SoundMachine */
    "Control": "Kontrola",
    "Start / Stop": "Zacznij / Zatrzymaj",
    "Volume": "Głośność",
    // "Reverb": "Reverb",
    "Instrument": "Instrument",
    "Mode": "Tryb",
    "Increase speed": "Zwiększaj prędkość",
    "BPM range": "Zakres BPM",
    "By bar": "Co kilka taktów",
    "bar": "takt",
    "By time": "Co jakiś czas",
    "Set time": "W ustalonym czasie ćwiczeń",
    "Percentage": "Procentowo",
    "Constant": "Nie zwiększaj",
    "Increase speed every": "Zwiększ prędkość co",
    "Initial time interval": "Początkowy odstęp czasu",
    "Time decrease percentage": "Procent zmniejszenia czasu",
    "Number of steps": "Ilość kroków",
    "Up and Down": "Szybciej i wolniej",
    "Shuffle": "Losowo",
    "Exercise Time": "Czas ćwiczenia",
    "Total time:": "Całkowity czas:",
    "Please select": "Proszę wybrać",
    "Select": "Wybierz",
    // "BPM": "BPM"

    /* Planner */
    "Stop": "Zatrzymaj",
    "Continue": "Kontynuuj",
    "Repeat": "Od początku",
    "After plan": "Po zakończeniu",
    "Step order": "Kolejność",

    "Plan progress": "Postęp planu",
    "Step progress": "Postęp kroku",

    /* Presets */
    "Title": "Nazwa",
    "Save current settings": "Zapisz bieżące ustawienia",
    "Edit": "Edytuj",
    "User presets": "Zapisane ustawienia",
    "Presets": "Presety",
    "Delete": "Usuń",
    "Save Preset": "Zapisz Ustawienia",
    "Cancel": "Anuluj",
    "Are you sure?": "Czy aby na pewno?",
    "Are you sure to delete current preset?": "Czy jesteś pewien, że chcesz usunąć to ustawienie?",
    "Save": "Zapisz",
    "Polyrhythms": "Polirytmy",
    "Basic": "Podstawowe",
    "Drum Patterns": "Motywy perkusyjne",
    "Afro-Cuban": "Afro-Kubańskie",
    "Other": "Inne",

    /* Import Dialog */
    "Import Presets": "Wczytaj Presety",
    "I can't read this file": "Nie potrafię odczytać tego pliku",
    "Import from file": "Importuj z pliku",
    "Export to file": "Eksportuj do pliku",
    "Confirm": "Potwierdź",

    /* TrackView */
    "Sequencer": "Sekwencer",

    /* Keyboard control panel */
    "Keyboard controls": "Skróty klawiszowe",

    /* Utils */

    "bars": {
        1: "takt",
        2: "takty",
        3: "takty",
        4: "takty",
        5: "taktów"
    },

    "hours": {
        1: "godzina",
        2: "godziny",
        3: "godziny",
        4: "godziny",
        5: "godzin"
    },

    "minutes": {
        1: "minuta",
        2: "minuty",
        3: "minuty",
        4: "minuty",
        5: "minut"
    },

    "seconds": {
        1: "sekunda",
        2: "sekundy",
        3: "sekundy",
        4: "sekundy",
        5: "sekund"
    },

    "hr": "godz.",
    "hrs": "godz."
}

export default pl;